import {
  localStorageGetChainCode,
  localStorageGetCustomerCode,
  localStorageGetShopCode,
  localStorageGetUserId,
} from "@/common/localStorageUtil";
import { CsvFileUpload, type FileReaderParams } from "@/common/fileUpload";
import { UploadMemberDocument } from "@/generated/graphql";
import type { UseMemberRegisterUploadParams } from "../types";

/**
 * 会員登録画面のCSVアップロード処理を扱う composable。
 */
export const useMemberRegisterUpload = (params: UseMemberRegisterUploadParams) => {
  const {
    overlay,
    uploadDialog,
    messagedialog,
    message,
    fileInput,
  } = params;

  /**
   * ファイル選択を開始する
   */
  const triggerFileInput = (): void => {
    fileInput.value?.click();
  };

  /**
   * ファイルを読み込みGraphQLを呼んでアップロードする
   */
  const uploadCsvFile = async (file: File): Promise<void> => {
    const uploadParams: FileReaderParams = {
      file,
      createUploadInput: (base64) => ({
        customer_code: localStorageGetCustomerCode(),
        chain_code: localStorageGetChainCode(),
        shop_code: localStorageGetShopCode(),
        csv: base64,
        user_id: localStorageGetUserId(),
      }),
      mutationDocument: UploadMemberDocument,
      resultDataKey: "uploadMember",
      handleUploadComplete: (_failed, resultMessage) => {
        messagedialog.value = true;
        message.value = resultMessage;
        uploadDialog.value = false;
      },
      handleError: (error, msg) => {
        overlay.value = false;
        messagedialog.value = true;
        message.value = msg;
        uploadDialog.value = false;
      },
    };

    uploadDialog.value = true;
    await CsvFileUpload.execute(uploadParams);
  };

  /**
   * アップロード @click
   */
  const onChangeFileUpload = async (e: Event): Promise<void> => {
    //ファイル名を取得しアップロードする
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];

    if (file) {
      await uploadCsvFile(file);
    }

    //ファイル名をクリアする
    const name = fileInput.value as HTMLInputElement;
    name.value = "";
  };

  return {
    triggerFileInput,
    onChangeFileUpload,
  };
};
